export const HOST_NAME = document.location.hostname;
export const PROD_HOST_NAME = 'app.commercialreview.nl';
export const GTAG_ENABLED = HOST_NAME === PROD_HOST_NAME;
export const GTAG_ID = 'UA-129742521-1';

export const SENTRY_ENABLED = HOST_NAME === PROD_HOST_NAME;
export const SENTRY_DSN = 'https://5aaffa618d41415a9e62f063b8c3c68a@o965139.ingest.sentry.io/5915887';
export const SENTRY_DOMAIN = HOST_NAME;
export const SENTRY_SAMPLE_RATE = 0.0;
